import Head from 'next/head'
import React, { FC } from 'react'
import env from 'src/@legacy/utilities/env'

const BreadcrumbTags: FC = () => {
  const breadcrumObject = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'freeC Asia',
        item: env.PUBLIC_EMPLOYER_APP_DOMAIN
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Dịch vụ Headhunt tích hợp công nghệ AI'
      }
    ]
  }
  return (
    <Head>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: `${JSON.stringify(breadcrumObject)}` }} />
    </Head>
  )
}

export default BreadcrumbTags
